import { useLanguage } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, ChevronRight } from "lucide-react";
import { homepageMiniFlows } from "@/content/industryProcessFlows";

export default function IndustryProcessPreview() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-24 border-t border-border bg-card/40">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mb-10">
          <p className="eyebrow mb-3">{t("Industry process templates")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            {t("Your process is different. Your data model should be different too.")}
          </h2>
          <p className="text-muted-foreground">
            {t("BEEDIGIT industry templates are built around real production flows — not generic dashboards. Each template defines work centers, process steps, critical indicators, quality checks, QR labels, downtime reasons and energy KPIs.")}
          </p>
        </div>

        <div className="space-y-4">
          {homepageMiniFlows.map((f) => (
            <Link
              key={f.slug}
              to={`/industries/${f.slug}`}
              className="block rounded-xl border border-border bg-background p-5 hover-glow"
            >
              <div className="flex items-baseline justify-between gap-4 mb-3">
                <h3 className="text-lg md:text-xl font-semibold">{t(f.title)}</h3>
                <span className="text-xs text-primary inline-flex items-center gap-1 shrink-0">
                  {t("Explore template")} <ArrowRight className="h-3 w-3" />
                </span>
              </div>
              <div className="flex items-center gap-1.5 overflow-x-auto pb-2">
                {f.steps.map((s, i) => (
                  <div key={s} className="flex items-center gap-1.5 shrink-0">
                    <span className="text-xs rounded-md border border-border bg-card px-2.5 py-1 whitespace-nowrap">
                      {t(s)}
                    </span>
                    {i < f.steps.length - 1 && (
                      <ChevronRight className="h-3.5 w-3.5 text-primary/70" />
                    )}
                  </div>
                ))}
              </div>
              <p className="mt-3 text-xs md:text-sm text-muted-foreground">
                <span className="text-foreground font-medium">{t("Key indicators:")} </span>
                {t(f.indicators)}
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-8">
          <Button asChild size="lg">
            <Link to="/industries">
              {t("Explore Industry Process Templates")} <ArrowRight className="ms-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}